import FilterListItemAbstract from "../../Abstract/Filter/FilterListItemAbstract";
import { FILTER, FILTER_ABSTRACT_STATE, MENU_ITEMS } from "../../Dashboard/Filters/Types";
import { DropDownButtonItemClickEvent } from "@progress/kendo-react-buttons";
import { Container, Position } from "puzzle";
import React from "react";
import { intersection } from "lodash";
import * as _ from "lodash";
import classNames from "classnames";

interface STATE extends FILTER_ABSTRACT_STATE {
}

type PROPS = {
  onItemClick: Function,
  selectedSearchId: number
}

class AdvancedSearchListItem extends FilterListItemAbstract<PROPS, STATE> {
  supplierView = true;
  countProperty: 'submissionCount' | 'jobPhaseCount' = 'jobPhaseCount';

  moduleDidMount = () => {
    this.setState({
      additionalLiClassName: 'tp-tasks-filter-list'
    })
  };

  /**
   * Menu items attached to each filter, order is important because handleItemClick function depends on it
   */
  ITEMS: MENU_ITEMS = [
    { text: this.translate('edit') },
    { text: this.translate('clone') },
    { text: this.translate('hide') },
    { text: this.translate('delete') }
  ];

  componentDidUpdate(prevProps: Readonly<{}>, prevState: STATE) {
    if (!_.isEqual(prevProps, this.props)) {
      this.setState({
        additionalLiClassName: `tp-tasks-filter-list ${this.props.currentItem.filterId === this.props.selectedSearchId ? 'tp-marked-filter' : ''}`
      });
    }
  }

  /**
   * Run callback function to trigger filter cloning
   */
  cloneFilter = () => {
    this.dispatch('openAdvancedSearchDialog', '', { modeData: { ...this.props.currentItem, mode: 'clone' } })
  };

  /**
   * Run callback function to trigger filter cloning
   */
  deleteFilter = () => {
    this.dispatch('deleteSavedSearch', '', {
      filterIndex: this.props.currentItem.filterId
    })
  };

  /**
   * Run callback function to trigger filter cloning
   */
  editFilter = () => {
    this.dispatch('openAdvancedSearchDialog', '', { modeData: { ...this.props.currentItem, mode: 'edit' } })
  };

  /**
   * Run callback function to trigger filter cloning
   */
  hideFilter = () => {
    const { currentItem } = this.props;
    this.dispatch('showHideSearch', '', {
      isFavoriteData: {
        isFavorite: !currentItem.isFavorite,
        filterName: currentItem.filterName
      }
    })
  };

  /**
   * Override
   */
  handleEnterFromParent = (currentItem: FILTER) => {
    this.dispatch('searchTaskListBySearchesClick', '', {
      filter: currentItem
    });
  };

  /**
   * Override
   */
  handleItemClick = (itemData: any, event: DropDownButtonItemClickEvent) => {
    const { itemIndex } = event;
    switch (itemIndex) {
      case 0:
        this.editFilter();
        break;
      case 1:
        this.cloneFilter();
        break;
      case 2:
        this.hideFilter();
        break;
      case 3:
        this.deleteFilter();
        break;
      default:
        break;
    }
  };

  /**
   * Override
   */
  handleFilterClick = (event: any) => {
    const skippedClasses = ['tp-filter-list-item-count',
      'tp-filter-list-item-name',
      'tp-filter-list-item-wrap',
      'tp-filter-list-item-settings',
      'tp-filter-list-item'];
    if (intersection(skippedClasses, event.target.classList).length) {
      const { currentItem } = this.props;
      this.props.onItemClick(currentItem);
      this.dispatch('searchTaskListBySearchesClick', Position.end, {
        filter: _.omit({ ...currentItem }, ['color'])
      });
    }
  };

  /**
   * @inheritdoc
   */
  public renderSearchNameWithCount = () => {
    const {
      jobPhaseCount,
      filterName
    } = this.props.currentItem;
    const jobPhaseCountLength = jobPhaseCount ? jobPhaseCount.toString().length : 0;
    const itemCountClass = classNames(
      'tp-filter-list-item-count tp-text-medium',
      {
        'tp-font-size-sm': jobPhaseCountLength < 5,
        'tp-font-size-xs': jobPhaseCountLength === 5,
        'tp-font-size-xxs': jobPhaseCountLength > 5,
      }
    )
    return (
      <Container
        alignItemsCenter
        displayFlex
        flex1
        className={'tp-filter-list-item-wrap tp-100'}
      >
        {
          _.isUndefined(jobPhaseCount) ?
            <i className={'tp-icon tp-icon-sm tp-loop'} aria-hidden={"true"} />
            :
            <div className={`${itemCountClass}`} tabIndex={-1}>{jobPhaseCount}</div>
        }
        <div className="tp-filter-list-item-name tp-font-size-sm" tabIndex={-1}>{filterName}</div>
      </Container>)
  }


}

export default AdvancedSearchListItem;
